<template>
  <div :class="[{'columns is-multiline is-mobile':layout==='column-2'}]">
    <div class="radioWrapper" :class="[{'column is-half':layout==='column-2'}, inputStyle, layout]" v-for="(label, index) in labels" :key="index">
      <label :for="label.id">
        <input
        type="radio"
        :name="tkey"
        :id="label.id"
        :value="label.value"
        v-model="radioValue"
        @focus="$emit('focus')"
        @blur="$emit('blur')">
        <i class="input-radio" :class="[inputStyle]"></i>
        <span>{{label.name}}</span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      radioValue: this.value
    }
  },
  props: {
    labels: {
      type: Array,
      default: () => {
        return []
      }
    },
    tkey: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    inputStyle: {
      type: String,
      default: 'radio'
    },
    layout: {
      type: String,
      default: '' // column-2
    }
  },
  watch: {
    'radioValue': function (n, o) {
      this.$emit('input', { key: this.tkey, value: this.radioValue })
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../../style/bulma/app.sass'

$column-gap: 7.5px
.columns
  margin: -$column-gap
  .column
    padding: $column-gap

.radioWrapper
  display: inline-block
  margin-right: 15px
  &.column-2
    margin-right: 0
    &.radio
      margin: 0
  label
    // display: flex
    // align-items: center
    width: 20px
    cursor: pointer
    input
      position: absolute
      opacity: 0
      visibility: hidden
      &:checked + .input-radio.radio
        background: #fff
        border: 1px solid #ccc
        &:after
          opacity: 1
          transform: scale(1)
          transition: all .2s ease-in-out
      &:checked + .input-radio.checkbox
        background: #fff
        border: 1px solid #ccc
        &:after
          position: absolute
          content: ""
          width: 12px
          height: 12px
          top: 2px
          left: 2px
          background: url('./assets/true.svg')
          background-size: contain
          background-position: center center
    .input-radio
      position: relative
      background: #fff
      border: 1px solid #ccc
      &.radio
        width: 22px
        height: 22px
        margin: 0
        border-radius: 50%
        vertical-align: -5px
        &:after
          position: absolute
          content: ""
          width: 12px
          height: 12px
          background-color: $primary3
          border-radius: 50%
          top: 4px
          left: 4px
          opacity: 0
          transform: scale(0)
      &.checkbox
        width: 16px
        height: 16px
        border-radius: none
        vertical-align: -2px
    span
      margin-left: 5px
      +mobile
        font-size: 14px

</style>
